var constants = require("../constants");
var host_lib =  require ("blended-hostlib-js")
let  host  = new host_lib ()


/*When the page loads, getinitData function will called*/
/*when user clicks on makeActive button, makeActive method will be called*/
/*When user clicks on detail button, getDetailData method will be called*/

var actions = {
	hostUrl : "",

	host : function  () {
		const _actions = this.flux.actions;
		return new host_lib (_actions.hostUrl)
	}, 
	getInitData: function(){
		var self = this;
		let opts = {};
		const _actions = this.flux.actions;

		_actions.host().getPackages (opts, (data, response) => {
			if(response){
				if(response.status === 200){
					self.dispatch ( constants.INIT_DATA , {data : data.items});
					self.flux.actions.getActiveTheme()
				} else {
					try {
					var obj = JSON.parse (response.text);
						self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": obj.message});
				    } catch(e) {
				    	self.dispatch (constants.ERROR_MESSAGE, {"error": true, "message": "Unable to parse error"});
				    }
				}
			} else if(data.message.search("the network is offline") > -1){
				self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "Network is offline."});
			}
		});

 	},

 	getUpdates: function(){
 		var self = this;
 		const _actions = this.flux.actions;

 		_actions.host().getUpdates (function (data, response) {
 			if(response){
 				if(response.status === 200 && data !== ""){
 					self.dispatch ( constants.UPDATES_DATA , {data: data});
 				}
 				else{
 					self.dispatch ( constants.UPDATES_DATA , {data: {"type":"Select"}});
 				}
 			} else {
 				self.dispatch ( constants.UPDATES_DATA , {data: {"type":"Select"}});
 			}
 		});
 	},

	makeActive: function(slug){
		/* this will activate the theme based on slug */
		var self =  this;
		const _actions = this.flux.actions;
		var body = {};

		slug = slug.toLowerCase();

		body["slug"] = slug;
		_actions.host().make_active (body, function (data, response) { 
			if(response){
				if(response.status === 200){
					self.flux.actions.getActiveTheme()
				}
				else{
					self.dispatch ( constants.DETAIL_DATA , {data : {"name": "  "}});
					try {
					var obj = JSON.parse (response.text);
						self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": obj.message});
				    } catch(e) {
				    	self.dispatch (constants.ERROR_MESSAGE, {"error": true, "message": "Unable to parse error"});
				    }
				}
			} else if(typeof data ==="object" && data.hasOwnProperty("message") && typeof data.message === "string" && data.message.search("the network is offline") > -1){
				self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "It seems you are offline. Please check your network connection and try again."});
			}
		});
	},

	getActiveTheme : function () {
		/* this will retrieve name of active theme */
		var self =  this;
		const _actions = this.flux.actions;

		_actions.host().getActiveTheme (function (data, response) {
			if(response){
				if(response.status === 200){
					self.dispatch ( constants.ACTIVE_THEME , {data : data});
					localStorage.setItem("active_theme", data);
				}
				else{
					try {
					var obj = JSON.parse (response.text);
						self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": obj.message});
				    } catch(e) {
				    	self.dispatch (constants.ERROR_MESSAGE, {"error": true, "message": "Unable to parse error"});
				    }
				}
			} else if(typeof data ==="object" && data.hasOwnProperty("message") && typeof data.message === "string" && data.message.search("the network is offline") > -1){
				self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "It seems you are offline. Please check your network connection and try again."});
			}
		});
	},

	getDetailData: function(account, slug){
		/* get details of a particular library using its primary key(slug) */
		var self = this;
		const _actions = this.flux.actions;

		account = account.toLowerCase();
		slug = slug.toLowerCase();
		_actions.host().localDetails (account, slug , function (data, response) {
			if(response){
				var resp = {};
				try{
					resp = JSON.parse(response.text);
				} catch(e){}
				if(response.status === 200){
					self.dispatch ( constants.DETAIL_DATA , {data : resp});
				}
				else{
					self.dispatch ( constants.DETAIL_DATA , {data : {"name": "  "}});
					try {
					var obj = JSON.parse (response.text);
						self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": obj.message});
				    } catch(e) {
				    	self.dispatch (constants.ERROR_MESSAGE, {"error": true, "message": "Unable to parse error"});
				    }
				}
			} else if(typeof data ==="object" && data.hasOwnProperty("message") && typeof data.message === "string" && data.message.search("the network is offline") > -1){
				self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "It seems you are offline. Please check your network connection and try again."});
			}
		});
	},

	buyLib: function(dependencies,slug){
		/* when clicks on buy button inside dependencies */
		alert("you are purchasing theme... " +dependencies + " " + slug);
	},

	addToCart: function(dependencies,slug){
		/* when clicks on Add To Cart button inside dependencies */
		alert("adding theme to cart... "+dependencies + " " + slug);
	},

	showPreview: function(user, slug){
		// user = user.toLowerCase();
		// slug = slug.toLowerCase();

		// var siteUrl =  window.location.href;
		// if (siteUrl.indexOf('wp-admin') >-1) {
		//     siteUrl =  siteUrl.split('wp-admin');
		//     var previewUrl =  siteUrl[0]  + "?" + "preview_theme" + "=" + user + "/" + slug;
		//     window.open(previewUrl, "_blank");
		// };
		alert("Coming soon");
	},

	editTheme: function(slug, accountSlug, type){
		accountSlug = accountSlug.toLowerCase();
		slug = slug.toLowerCase();

		localStorage.setItem("slug", slug);
		localStorage.setItem("accountSlugSource", accountSlug);
		localStorage.setItem("type", type);
		window.location.href = "?page=Source+Code";
	},

	clone: function(action, accountSlug = "", slug = "", slug2 = "", packageName = ""){
		/* for cloning a theme */
		const _actions = this.flux.actions;
		var self = this, status = "loggedIn";

		accountSlug = accountSlug.toLowerCase();
		slug = slug.toLowerCase();
		slug2 = slug2.toLowerCase();

		if (!localStorage.getItem("session_key")){
			status = "noAcc";
		}
		switch (action){
			case "open":
				self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "Please wait...", "isLoading": true});
				_actions.host().localPackageGet (accountSlug, slug, (data, response) => {
					if(response){
						var resp;
						try{
						   resp = JSON.parse(response.text);
						} catch(e){
							resp = {};
						}
						if(response.status === 200){
							self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
							self.dispatch (constants.CLONE_DATA, {"popup": true,  "accountSlug": accountSlug, "slug": slug});
						} else if(response.status === 500 && resp.message == "Session not authenticated"){
							self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
							self.dispatch (constants.SIGNUP_POPUP, {"popup": true, "data": "", "action": {"action":"cloneOpen", "accountSlug":accountSlug, "slug": slug }, "slug": accountSlug+"/"+slug }) // redirect to on-boarding popup
						} else {
							self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": resp.message});
						}
					} else if(typeof data ==="object" && data.hasOwnProperty("message") && typeof data.message === "string" && data.message.search("the network is offline") > -1){
						self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "It seems you are offline. Please check your network connection and try again."});
					}
				});
				break;
			case "close":
				self.dispatch (constants.CLONE_DATA, {"popup": false});
				break;
			case "submit":
				self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": false, "message": "Please wait...", "isLoading": true});
				if(status === "noAcc"){
					_actions.host().localPackageGet (accountSlug, slug2, (data, response) => {
						if(response){
							var resp;
							try{
							   resp = JSON.parse(response.text);
							} catch(e){
								resp = {};
							}
							if((response.status === 200 && response.text === "null") || (response.status === 500 && resp.message == "Session not authenticated")){
								var body = {"name": slug};
								_actions.localClone(accountSlug, slug, slug2, body, {});
							} else if(response.status === 200 && response.text !== "null"){
								self.dispatch (constants.ERROR_MESSAGE, {"popup": false, "error": true});
							} else if(response.status === 500 && resp.message == "Session not authenticated"){
								self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
								self.dispatch (constants.SIGNUP_POPUP, {"popup": true, "data": "", "action": {"action":"cloneSubmit", "accountSlug":accountSlug, "slug": slug, "slug2": slug2 }, "slug": accountSlug+"/"+slug2}) // redirect to on-boarding popup
							} else {
								self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": resp.message});
							}
						} else if(typeof data ==="object" && data.hasOwnProperty("message") && typeof data.message === "string" && data.message.search("the network is offline") > -1){
							self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "It seems you are offline. Please check your network connection and try again."});
						}
					});
				} else if(status === "loggedIn") {
					_actions.host().localPackageGet (accountSlug, slug2,  (data, response) => {
						if(response){
							var resp;
							try{
							   resp = JSON.parse(response.text);
							} catch(e){
								resp = {};
							}
							if((response.status === 200 && response.text === "null") || response.status === 500 && resp.message == "Package does not exist.") {
								_actions.pullPackage(accountSlug, slug2, slug, {});
							} else if(response.status === 200 && response.text !== "null"){
								self.dispatch (constants.ERROR_MESSAGE, {"popup": false, "error": true});
							} else if(response.status === 500 && resp.message == "Session not authenticated"){
								self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
								self.dispatch (constants.SIGNUP_POPUP, {"popup": true, "data": "", "action": {"action":"cloneSubmit", "accountSlug":accountSlug, "slug": slug, "slug2": slug2 }, "slug": accountSlug+"/"+slug2}) // redirect to on-boarding popup
							} else {
								self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": resp.message});
							}
						} else if(typeof data ==="object" && data.hasOwnProperty("message") && typeof data.message === "string" && data.message.search("the network is offline") > -1){
							self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "It seems you are offline. Please check your network connection and try again."});
						}
					});
				}
		}
	},

	pullPackage: function(accountSlug, slug2, slug, opts = {}){  // especially for clone
		var self = this;
		const _actions = this.flux.actions;
		var accountSlug2 = localStorage.getItem("userSlug");
		if(accountSlug === accountSlug2){
			accountSlug2 = accountSlug;
		}

		accountSlug = accountSlug.toLowerCase();
		slug = slug.toLowerCase();
		accountSlug2 = accountSlug2.toLowerCase();

		_actions.host().pullPackage (accountSlug2, slug2, opts, (data, response) => {
			if(response){
				try {
					var obj = JSON.parse(response.text);
				} catch (e){
					var obj = {};
				}
				if(response.status === 200){
					self.dispatch (constants.ERROR_MESSAGE, {"popup": false, "error": true});
				} else if(response.status === 500 && obj.message === "Package does not exist."){
					_actions.host().localClone(accountSlug, slug, accountSlug2, slug2, {"name": slug}, {}, (data, response) => {
						if(response){
							var resp = {};
							try{
							   resp = JSON.parse(response.text);
							} catch(e){
								resp = {};
							}
							if (response.status === 200) {
								_actions.draftCreate(accountSlug, slug2, {"packageHash": "", "jptf": resp}, {});
							} else if(response.status === 500 && resp.message == "Session not authenticated"){
								self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
								self.dispatch (constants.SIGNUP_POPUP, {"popup": true, "data": "", "action": {"action":"pullPackage", "accountSlug":accountSlug, "slug2": slug2, "slug": slug}, "slug": accountSlug+"/"+slug2}) // redirect to on-boarding popup
							} else {
								_actions.clone("close");
								self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": resp.message});
							}
						} else if(typeof data ==="object" && data.hasOwnProperty("message") && typeof data.message === "string" && data.message.search("the network is offline") > -1){
							self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "It seems you are offline. Please check your network connection and try again."});
						} else {
							_actions.clone("close");
							self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": data.message});
						}
					});
				} else if(response.status === 500 && obj.message == "Session not authenticated"){
					self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
					self.dispatch (constants.SIGNUP_POPUP, {"popup": true, "data": "", "action": {"action":"pullPackage", "accountSlug":accountSlug, "slug2": slug2, "slug": slug}, "slug": accountSlug+"/"+slug2}) // redirect to on-boarding popup
				} else {
					_actions.clone("close");
					self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": obj.message});
				}
			}else if(typeof data ==="object" && data.hasOwnProperty("message") && typeof data.message === "string" && data.message.search("the network is offline") > -1){
				self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "It seems you are offline. Please check your network connection and try again."});
				_actions.localClone(accountSlug, slug, slug2, body, opts);
			}
		});
	},

	draftCreate: function(accountSlug, slug2, body, opts = {}){
		const _actions = this.flux.actions;
		var self = this;
		var accountSlug1 = localStorage.getItem("userSlug");
		if(accountSlug === accountSlug1){
			accountSlug1 = accountSlug;
		}

		accountSlug = accountSlug.toLowerCase();
		slug2 = slug2.toLowerCase();

		_actions.host().draftCreate(accountSlug1, slug2, body, opts, (data, response) => {
			if(response){
				var obj = {};
				try {
					 obj = JSON.parse(response.text);
				} catch (e){
					 obj = {};
				}
				if(response.status === 200){
					self.dispatch (constants.ERROR_MESSAGE, {"popup": false, "error": false});
					_actions.clone("close");
					_actions.cloneSuccess("open", accountSlug, slug2);
				} else if (response.status === 500 && typeof obj === "object" && obj.hasOwnProperty("message") &&  typeof obj.message == "string" && obj.message.startsWith("Package Creation limit Reached")){
					self.dispatch (constants.ERROR_MESSAGE, {"popup": false, "error": false});
					_actions.clone("close");
					_actions.cloneWarning("open", slug2);
				} else if(response.status === 500 && obj.message == "Session not authenticated"){
					self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
					self.dispatch (constants.SIGNUP_POPUP, {"popup": true, "data": "", "action": {"action":"draftCreate", "accountSlug":accountSlug, "slug2": slug2, "body":body}, "slug": accountSlug+"/"+slug2}) // redirect to on-boarding popup
				} else if (response.status === 500 && obj.message.toLowerCase().indexOf("package name already in use") > -1){
					self.dispatch (constants.ERROR_MESSAGE, {"popup": false, "error": true});
				} else if(response.status === 500 && obj.message == "Draft has been changed. Please pull it first"){
					_actions.localDelete(accountSlug, accountSlug1, slug2);
				} else {
					_actions.clone("close");
					var dataa = null;
					if(obj.hasOwnProperty("data")){
						dataa = obj.data;
					}
					self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": obj.message, "data": dataa});
				}
			} else if(typeof data ==="object" && data.hasOwnProperty("message") && typeof data.message === "string" && data.message.search("the network is offline") > -1){
				self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "It seems you are offline. Please check your network connection and try again."});
			}
		});
	},

	localClone: function(accountSlug, slug, slug2, body, opts){
		var self = this;
		const _actions = this.flux.actions;

		accountSlug = accountSlug.toLowerCase();
		slug = slug.toLowerCase();
		slug2 = slug2.toLowerCase();

		_actions.host().localClone(accountSlug, slug, accountSlug, slug2, body, opts, (data, response) => {
			if(response){
				try {
					var obj = JSON.parse(response.text);
				} catch (e){
					var obj = {};
				}
				if(response.status === 200){
					self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
					_actions.clone("close");
					_actions.cloneSuccess("open", accountSlug, slug2);
					_actions.getActiveTheme();
				} else if (response.status === 500 && obj.message.search("is not a valid Package") >-1){
					_actions.clone("close");
					self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": obj.message});
				} else if (response.status === 500) {
					self.dispatch (constants.ERROR_MESSAGE, {"popup": false, "error": true, "message": obj.message});
				}
			} else if(typeof data ==="object" && data.hasOwnProperty("message") && typeof data.message === "string" && data.message.search("the network is offline") > -1){
				self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "It seems you are offline. Please check your network connection and try again."});
			} else {
				_actions.clone("close");
				self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": data.message});
			}
		});
	},

	localDelete: function (accountSlug, accountSlug1, slug2) {
		var self = this;
		const _actions = this.flux.actions;

		accountSlug = accountSlug.toLowerCase();
		accountSlug1 = accountSlug1.toLowerCase();
		slug2 = slug2.toLowerCase();

		_actions.host().localDelete(accountSlug1, slug2, {"name": slug2}, (data, response) => {
			if(response){
				try {
					var obj = JSON.parse(response.text);
				} catch (e){
					var obj = {};
				}
				if(response.status === 200){
					self.dispatch (constants.ERROR_MESSAGE, {"popup": false, "error": false});
					_actions.clone("close");
					_actions.cloneSuccess("open", accountSlug, slug2);
				} else {
					_actions.clone("close");
					self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": obj.message});
				}
			} else if(typeof data ==="object" && data.hasOwnProperty("message") && typeof data.message === "string" && data.message.search("the network is offline") > -1){
				self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "It seems you are offline. Please check your network connection and try again."});
			} else {
				_actions.clone("close");
				self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": data.message});
			}
		})

	},

	snapshot: function(action, version = null, package_name= "", data = null){
		/* for snapshot a theme  */
		package_name = package_name.toLowerCase();
		var accountSlug = package_name.split("/")[0];
		var slug = package_name.split("/")[1];
		var self = this;
		var _data = data;
		const _actions = this.flux.actions;
		this.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "Please wait...", "isLoading": true});
		switch(action){
			case "open":
					_actions.host().snapshot(package_name, (data, response) => {
						if(response){
							var resp = {};
							try {
								if(response.hasOwnProperty("text")){
									resp = JSON.parse(response.text);
								}
							} catch(e){};
							if(response.status === 200){
								if(typeof resp === "object" && resp.hasOwnProperty("items") && resp.items instanceof Array){
									// self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
									// self.dispatch(constants.SNAPSHOT_VERSION_POPUP, {"popup": true, "data": resp.items});
									if(resp.items.length > 0){
										for(var i in resp.items){
											resp.items[i]["canonical"] = false;
										}
										_actions.host().canonicalDetails(accountSlug, slug, (data, response) => {
											let canonicalVersion = "";
											if(response){
												var obj= {};
												try{
													obj = JSON.parse(response.text);
												} catch (e){}
												if(response.status === 200){
													canonicalVersion = obj.label;
												}else if(response.status === 500 && resp.message == "Session not authenticated"){
													self.dispatch (constants.SIGNUP_POPUP, {"popup": true, "data": "", "action":  {"action":"snapshotOpen", "version": version, "package_name": package_name, "data": _data}, "slug": package_name}) // redirect to on-boarding popup
													self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
												} else {
													canonicalVersion = "";
													self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": data.message});
												}
											} else if(typeof data ==="object" && data.hasOwnProperty("message") && typeof data.message === "string" && data.message.search("the network is offline") > -1){
												self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "It seems you are offline. Please check your network connection and try again."});
											} else {
												canonicalVersion = "";
												self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": data.message});
											}
											self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
											for(var i in resp.items){
												if(resp.items[i]["label"] === canonicalVersion){
													resp.items[i]["canonical"] = true;
												}
											}
											self.dispatch(constants.SNAPSHOT_VERSION_POPUP, {"popup": true, "data": resp.items});
										});
									} else {
										self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
										self.dispatch(constants.SNAPSHOT_VERSION_POPUP, {"popup": true, "data": resp.items});
									}
								}
							} else if(response.status === 500 && resp.message === "out-of-sync"){
								_actions.snapshotError("open"); //  open out of sync model  
							} else if(response.status === 500 && resp.message.toLowerCase().indexOf("package does not exist") > -1){
								self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "Before making Snapshot, Please Push your package \"" + slug + "\" first."});
							} else{
								self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": resp.message});
							}
						} else if(typeof data ==="object" && data.hasOwnProperty("message") && typeof data.message === "string" && data.message.search("the network is offline") > -1){
							self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "It seems you are offline. Please check your network connection and try again."});
						}  else if (data.message === "No session_key"){  // condition for no session_key
							self.dispatch (constants.SIGNUP_POPUP, {"popup": true, "data": "", "action":  {"action":"snapshotOpen", "version": version, "package_name": package_name, "data": data}, "slug": package_name}) // redirect to on-boarding popup
							self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
						} else {
							self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": data.message});
						}
					})
					break;
			case "close":
					self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
					this.dispatch(constants.SNAPSHOT_VERSION_POPUP, {"popup": false});
					break;
			case"submit":
					_actions.host().versionCreateSnapshot(accountSlug, slug, {"label": version}, (data, response) => {
						if(response){
							var resp = {};
							try{
								resp = JSON.parse(response.text);
							} catch(e){}
							if(response.status === 200){
								this.dispatch(constants.SNAPSHOT_VERSION_POPUP, {"popup": true, "data": resp.items});
								this.dispatch(constants.ERROR_MESSAGE, {"popup": false});
							} else if (response.status === 500 && (resp.message === "Draft has been changed. Please pull it first"  || resp.message === "out-of-sync")) {
								_actions.snapshotError("open");  // open out of sync model
								_actions.snapshot("close");
							} else if (response.status === 500 && resp.message.toLowerCase().indexOf("version label exist") > -1){
								self.dispatch (constants.ERROR_MESSAGE, {"popup": false, "error": true, "message": "Version label exist with this package. Please enter different label name."});
							} else {
								self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": resp.message});
							}
						} else if(typeof data ==="object" && data.hasOwnProperty("message") && typeof data.message === "string" && data.message.search("the network is offline") > -1){
							self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "It seems you are offline. Please check your network connection and try again."});
						}  else if (data.message === "No session_key"){  // condition for no session_key
							self.dispatch (constants.SIGNUP_POPUP, {"popup": true, "data": "", "action":  {"action":"snapshotSubmit", "version": version, "package_name": package_name, "data": data}, "slug": package_name}) // redirect to on-boarding popup
							self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
						} else {
							self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": data.message});
						}
					});
					break;
		}
	},

	makeCanonicalSnapshot: function(label, accountSlug, slug, versions){
		var self = this;
		const _actions = this.flux.actions;
		_actions.host().canonicalSet(accountSlug, slug, JSON.stringify({"label": label, "is_canonical": true}), (data, response) => {
			if(response){
				var resp = {};
				try {
					resp = JSON.parse(response.text);
				} catch(e){};
				if(response.status === 200){
					for(var i in versions){
						if(versions[i]["label"] === label){
							versions[i]["canonical"] = true;
						} else {
							versions[i]["canonical"] = false;
						}
					}
					self.dispatch(constants.SNAPSHOT_VERSION_POPUP, {"popup": true, "data": versions});
				} else if (data.message === "No session_key"){  // condition for no session_key
					self.dispatch (constants.SIGNUP_POPUP, {"popup": true, "data": "", "action":  {"action":"makeCanonical", "label": label, "accountSlug": accountSlug, "slug": slug, "versions": versions}, "slug": accountSlug + "/" + slug}) // redirect to on-boarding popup
					self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
				} else {
					self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": resp.message});
				}
			} else if(typeof data ==="object" && data.hasOwnProperty("message") && typeof data.message === "string" && data.message.search("the network is offline") > -1){
				self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "It seems you are offline. Please check your network connection and try again."});
			}  else {
				self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": data.message});
			}
		});
	},

	snapshotError (action) {
		var self = this;
		const _actions = this.flux.actions;
		this.dispatch (constants.ERROR_MESSAGE, {"popup": false});
		switch (action) {
			case "open":
				this.dispatch ( constants.SNAPSHOT_ERROR , {"popup": true});
				break;
			case "close":
				this.dispatch ( constants.SNAPSHOT_ERROR , {"popup": false});
				break;
			case "submit":
				this.dispatch ( constants.SNAPSHOT_ERROR , {"popup": false});
		}
	},

	pull :  function (slug) {
		/* for pull a theme */
		var self = this;
		const _actions = this.flux.actions;

		slug = slug.toLowerCase();

		var opts = { 
		  'force': false // {String} boolean that forces a pulled package to overwrite the local package
		};
		var sendData =  slug.split("/");
		var i = 0, fileData = [];
		var loopArray = function(accountSlug, slug, fileNames, action, showPullDiff= false){
			if(i < fileNames.length){
				_actions.getFile(accountSlug, slug, fileNames[i], action,  function(data){
						var file = {};
						file[fileNames[i]] = data;
						fileData.push(file);
						i++;
						loopArray(accountSlug, slug, fileNames, action, showPullDiff);
				});
			} else {
				if(showPullDiff){
					_actions.pullDiff(true, "", "", fileData)
				} else {
					_actions.confirmPull("open","", "", fileData);
				}
				// self.dispatch (constants.ERROR_MESSAGE, {"popup": false });
			}
		}
		self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "Please wait...", "isLoading": true});
		_actions.host().pullPackage (sendData[0], sendData[1],  opts,  function (data, response) {
			if(response){
				if(response.status === 200){
					var resp;
					try{
					   resp = JSON.parse(response.text);
					} catch(e){
						resp = {};
					}
					if(resp.hasOwnProperty("flag") && resp.flag && resp.hasOwnProperty("fileList") && resp.fileList.length > 0){
						self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "Please wait...", "isLoading": true});
						loopArray(sendData[0], sendData[1], resp.fileList, "pull", true) // file names	
					} else if(resp.hasOwnProperty("fileList") && resp.fileList.length > 0 && resp.hasOwnProperty("draft")){
						self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "Please wait...", "isLoading": true});
					 	loopArray(sendData[0], sendData[1], resp.fileList, "pull") // file names						 	
					} else if (resp.hasOwnProperty("force") && resp.force) {
						self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": false, "message": "Pull is done successfully."});
					} else {
						self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": 'Package "'+  sendData[1]  + '" is already in sync. No pull is necessary.' });
					}
				} else {
					try {
						var obj = JSON.parse (response.text);
						if(obj.message.search("not authenticated") > -1){
							self.dispatch (constants.SIGNUP_POPUP, {"popup": true, "data": "", "action": {"action":"pull"}, "slug": slug}) // redirect to on-boarding popup
							self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
						} else {
							self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": obj.message, "isLoading": false});
						}
				    } catch(e) {
				    	self.dispatch (constants.ERROR_MESSAGE, {"error": true, "message": "Unable to parse error", "isLoading": false});
				    }
				}
			}  else if (data.message === "No session_key"){  // condition for no session_key
				self.dispatch (constants.SIGNUP_POPUP, {"popup": true, "data": "", "action":  {"action":"pull"}, "slug": slug}) // redirect to on-boarding popup
				self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
			} else if(typeof data ==="object" && data.hasOwnProperty("message") && typeof data.message === "string" && data.message.search("the network is offline") > -1){
				self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "It seems you are offline. Please check your network connection and try again."});
			}  else {
				try {
					if(JSON.parse(JSON.stringify(data)).rawResponse.search("not authenticated") > -1){
						self.dispatch (constants.SIGNUP_POPUP, {"popup": true, "data": "", "action": {"action":"pull"}, "slug": slug}) // redirect to on-boarding popup
						self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
					} else {
						self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": data.message, "isLoading": false});
					}
				} catch (e){
					self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": data.message, "isLoading": false});
				}
				
			}
		});
	},

	push: function (slug){
		var self = this;
		const _actions = this.flux.actions;

		slug = slug.toLowerCase();

		var body = { 
		  'force': false // {String} boolean that forces a pulled package to overwrite the local package
		};
		var sendData =  slug.split("/");
		var i = 0, fileData = [];
		function loopArray(accountSlug, slug,fileNames, packageHash,action, showPushDiff = false, getFile = false){
			if(i < fileNames.length){
				_actions.getFile(accountSlug, slug, fileNames[i], action, function(data){
						var file = {};
						file[fileNames[i]] = data;
						fileData.push(file);
						i++;
						loopArray(accountSlug, slug, fileNames, packageHash, action, showPushDiff, getFile);
				});
			} else {
				if(showPushDiff){
					_actions.pushDiff(true, "", "", fileData, packageHash);
				} else if (getFile) {
					_actions.pushDiff(false, accountSlug, slug, fileNames, packageHash); //submit
				} else {
					_actions.confirmPush("open", "", "", fileData, packageHash);
				}
				// self.dispatch (constants.ERROR_MESSAGE, {"popup": false });
			}
		}
		self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "Please wait...", "isLoading": true});
		_actions.host().pushPackage (sendData[0], sendData[1],  body,  function (data, response) {
			if(response){
				if(response.status === 200){
					var resp;
					try{
					   resp = JSON.parse(response.text);
					} catch(e){
						resp = {};
					}
					if (resp.hasOwnProperty("flag") && resp.flag && resp.hasOwnProperty("fileList") && resp.fileList.length > 0) {
						self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "Please wait...", "isLoading": true});
						loopArray(sendData[0], sendData[1], resp.fileList, resp.packageHash, "push", true) // file names	
					} else if (resp.hasOwnProperty("force") && resp.force) {
						self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "Please wait...", "isLoading": true});
						loopArray(sendData[0], sendData[1], resp.fileList, resp.packageHash, "push", false, true)
					} else if(resp.hasOwnProperty("fileList") && resp.fileList.length > 0 && resp.hasOwnProperty("packageHash")){
						self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "Please wait...", "isLoading": true});
						var fileList = resp.fileList;
					 	loopArray(sendData[0], sendData[1], fileList, resp.packageHash, "push") // file names
					}  else if (resp.draft !== undefined && !(resp.draft instanceof Array)){
						self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": false, "message": "Push is done successfully." });
					} else {
						self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": 'Package "'+  sendData[1]  + '" is already in sync. No push is necessary.' });
					} 
				} else {
					try {
						var obj = JSON.parse (response.text);
						if(obj.message.search("not authenticated") > -1){
							self.dispatch (constants.SIGNUP_POPUP, {"popup": true, "data": "", "action": {"action":"push"}, "slug": slug}) // redirect to on-boarding popup
							self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
						} else {
							self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": obj.message, "isLoading": false,  "data": obj.data});
						}
				    } catch(e) {
				    	self.dispatch (constants.ERROR_MESSAGE, {"error": true, "message": "Unable to parse error", "isLoading": false});
				    }
				}
			}  else if(typeof data ==="object" && data.hasOwnProperty("message") && typeof data.message === "string" && data.message.search("the network is offline") > -1){
				self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "It seems you are offline. Please check your network connection and try again."});
			}  else if (data.message === "No session_key"){  // condition for no session_key
				self.dispatch (constants.SIGNUP_POPUP, {"popup": true, "data": "", "action": "push", "slug": slug}) // redirect to on-boarding popup
				self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
			} else {
				try {
					if(JSON.parse(JSON.stringify(data)).rawResponse.search("not authenticated") > -1){
						self.dispatch (constants.SIGNUP_POPUP, {"popup": true, "data": "", "action": {"action":"push"}, "slug": slug}) // redirect to on-boarding popup
						self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
					} else {
						self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": data.message, "isLoading": false});
					}
				} catch (e){
					self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": data.message, "isLoading": false});
				}
			}
		});
	},

	getFile: function(accountSlug, slug, fileName, action, callback){
		var origianalFileName = fileName;
		fileName = fileName.replace(/\//g , "*");
		var _action = action;
		var self = this;

		accountSlug = accountSlug.toLowerCase();
		slug = slug.toLowerCase();
		const _actions = this.flux.actions;

		_actions.host().getFile(accountSlug, slug, fileName, function(data, response){
			if(response){
				if(response.status === 200){
					return callback(JSON.parse(response.text));
				} else if (response.status === 500){
					try {
						var obj = JSON.parse (response.text);
						if(obj.message.search("not authenticated") > -1){
							self.dispatch (constants.SIGNUP_POPUP, {"popup": true, "data": "", "action": {"action" :_action}, "slug": accountSlug + "/" + slug}) // redirect to on-boarding popup
							self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
						} else {
							// return callback ({"remote": "", "local": ""});
							self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "Invalid Directory/File found.", "isLoading": false,  "data": {[origianalFileName]: "There is something wrong in either Directory/File or its name."}});
						}
					} catch(e) {
					    self.dispatch (constants.ERROR_MESSAGE, {"error": true, "message": "Unable to parse error", "isLoading": false});
					}
				}  else {
					// return callback ({"remote": "", "local": ""});
					self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "Invalid Directory/File found.", "isLoading": false,  "data": {[origianalFileName]: "There is something wrong in either Directory/File or its name."}});
				}
			} else if (data.message === "No session_key"){  // condition for no session_key
				self.dispatch (constants.SIGNUP_POPUP, {"popup": true, "data": "", "action":{"action": _action}, "slug": slug}) // redirect to on-boarding popup
				self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
			}  else if(typeof data ==="object" && data.hasOwnProperty("message") && typeof data.message === "string" && data.message.search("the network is offline") > -1){
				self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "It seems you are offline. Please check your network connection and try again."});
			}  else {
				try{
					if(JSON.parse(JSON.stringify(data)).rawResponse.search("not authenticated") > -1){
						self.dispatch (constants.SIGNUP_POPUP, {"popup": true, "data": "", "action": {"action" :_action}, "slug": accountSlug + "/" + slug}) // redirect to on-boarding popup
						self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
					} else {
						// return callback ({"remote": "", "local": ""});
						self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "Invalid Directory/File found.", "isLoading": false,  "data": {[origianalFileName]: "There is something wrong in either Directory/File or its name."}});
					}
				} catch(e){
					self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "Invalid Directory/File found.", "isLoading": false,  "data": {[origianalFileName]: "There is something wrong in either Directory/File or its name."}});
				}
			}
		});	
	},

	install: function (slug, label){
		/* for installing a theme  */
		var self = this;
		const _actions = this.flux.actions;
		var opts = { 
		  'version': label,
		  'force': true // {String} boolean that forces a pulled package to overwrite the local package
		};
		console.log(slug);
		var sendData =  slug.split("/");
		
		
	},

	openSource: function(slug){
		alert("Coming soon");
	},

	getDependecies : function (slug) {
		/* for dependencies packages */
		var self  = this;
		const _actions = this.flux.actions;

		_actions.host().getDependencies (slug,  function (data, response) {
			if(response){
				if(response.status === 200){
					self.dispatch ( constants.DEPENDENCY_DATA , {data : data});
				}
				else{
					try {
					self.dispatch ( constants.DEPENDENCY_DATA , {data : {}});
					var obj = JSON.parse (response.text);
						self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": obj.message});
				    } catch(e) {
				    	self.dispatch (constants.ERROR_MESSAGE, {"error": true, "message": "Unable to parse error"});
				    }
				}	
			} else if(data.message.search("the network is offline") > -1){
				self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "Network is offline."});
			}
		});
	},

	getLicenses : function (slug){
		/* for licences */
		var self = this;
		const _actions = this.flux.actions;

		_actions.host().getLicenses (slug, (data, response)=> {
			if(response){
				if(response.status === 200){
					self.dispatch (constants.LICENSE_DATA , {data : data});
				}
				else{
					try{
						var obj = JSON.parse (response.text);
							// self.dispatch (constants.ERROR_MESSAGE , {"popup": true, "error": true, "message": obj.message })
					} catch(e){
							// self.dispatch ( constants.ERROR_MESSAGE, {"popup": true, "message": "Unable to parse error"});
					}
				}
			} else if(data.message.search("the network is offline") > -1){
				self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "Network is offline."});
			}
		})
	},

	closeAlertPopup: function (){
		this.dispatch (constants.RESETPOPUP)
	},

	pushDiff : function (flag,accountSlug, slug, files={}, packageHash = "") {
		var self = this;
		const _actions = this.flux.actions;

		accountSlug = accountSlug.toLowerCase();
		slug = slug.toLowerCase();

		if(flag){
			self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
			this.dispatch (constants.PUSH_DIFF, {"popup": true, "data": files, "packageHash": packageHash});
		} else if(Object.keys(files).length === 0 && files.constructor === Object){
			self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
			this.dispatch (constants.PUSH_DIFF, {"popup": false});
		} else {
			var body = {
				'force': false,
				'pushToHub': true,
				'packageHash': packageHash,
				'replaceFromLocalList': files
			};
			self.dispatch (constants.PUSH_DIFF, {"popup": false});
			self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "Please wait...", "isLoading": true});
			setTimeout(function(){
				_actions.host().pushPackage (accountSlug, slug, body,  function (data, response) {
					if (response) {
						if (response.status === 200) {
							self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": false, "message": "Push is done successfully."});	
						} else {
							try {
								var obj = JSON.parse (response.text);
								if(obj.message.search("not authenticated") > -1){
									self.dispatch (constants.SIGNUP_POPUP, {"popup": true, "data": "", "action": {"action":"pushDiff", "files": files, "packageHash": packageHash}, "slug": accountSlug + "/" + slug}) // redirect to on-boarding popup
									self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
								} else {
									self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": obj.message, "isLoading": false, "data": obj.data});
								}
						    } catch(e) {
						    	self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": obj.message, "isLoading": false, "data": obj.data});
						    }
						}
					}  else if(typeof data ==="object" && data.hasOwnProperty("message") && typeof data.message === "string" && data.message.search("the network is offline") > -1){
						self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "It seems you are offline. Please check your network connection and try again."});
					}  else {
						try {
							if(JSON.parse(JSON.stringify(data)).rawResponse.search("not authenticated") > -1){
								self.dispatch (constants.SIGNUP_POPUP, {"popup": true, "data": "", "action": {"action":"pushDiff", "files": files, "packageHash": packageHash}, "slug": accountSlug + "/" + slug}) // redirect to on-boarding popup
								self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
							} else {
								self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": data.message, "isLoading": false});
							}
						} catch (e){
								self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": data.message, "isLoading": false});
						}	
					}
				});
			}, 500);
			
		}
	},

	confirmPush : function(action, accountSlug, slug, files = {}, packageHash = ""){
		const _actions = this.flux.actions;
		var self = this;

		accountSlug = accountSlug.toLowerCase();
		slug = slug.toLowerCase();

		self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
		switch(action){
			case "open":
				this.dispatch (constants.CONFIRM_PUSH, {"popup": true, "data": files, "packageHash": packageHash});
				break;
			case "close":
				this.dispatch (constants.CONFIRM_PUSH, {"popup": false});
				break;
			case "submit":
				this.dispatch (constants.CONFIRM_PUSH, {"popup": false, "data": files, "packageHash": packageHash});
				this.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "Please wait...", "isLoading": true});
				setTimeout(function(){
					_actions.pushDiff(true, accountSlug, slug, files, packageHash);
				}, 500);
				break;
		}
	},
	
	pullDiff :function (flag, accountSlug, slug, files = {}) {
		var self = this;
		const _actions = this.flux.actions;

		accountSlug = accountSlug.toLowerCase();
		slug = slug.toLowerCase();

		if(flag){
			self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
			this.dispatch (constants.PULL_DIFF, {"popup": true, "data": files});
		} else if(Object.keys(files).length === 0 && files.constructor === Object){
			self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
			this.dispatch (constants.PULL_DIFF, {"popup": false});
		} else {
			var body = {
				'replaceList': files
			};
			self.dispatch(constants.PULL_DIFF, {"popup": false});
			self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "Please wait...", "isLoading": true});
			setTimeout(function(){
				_actions.host().localUpdate(accountSlug, slug, body, (data, response) => {
					if(response){
						if(response.status === 200){
							self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": false, "message": "Pull is done successfully."});
						} else {
							try {
								var obj = JSON.parse (response.text);
								if(obj.message.search("not authenticated") > -1){
									self.dispatch (constants.SIGNUP_POPUP, {"popup": true, "data": "", "action": {"action":"pullDiff", "files": files}, "slug": accountSlug + "/" + slug}) // redirect to on-boarding popup
									self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
								} else{
								self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": obj.message, "isLoading": false});
								}
						    } catch(e) {
						    	self.dispatch (constants.ERROR_MESSAGE, {"error": true, "message": "Unable to parse error", "isLoading": false});
						    }
						}
					}  else if(typeof data ==="object" && data.hasOwnProperty("message") && typeof data.message === "string" && data.message.search("the network is offline") > -1){
						self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "It seems you are offline. Please check your network connection and try again."});
					}  else {
						try {
							if (JSON.parse(JSON.stringify(data)).rawResponse.search("not authenticated") > -1){
								self.dispatch (constants.SIGNUP_POPUP, {"popup": true, "data": "", "action": {"action":"pullDiff", "files": files}, "slug": accountSlug + "/" + slug}) // redirect to on-boarding popup
								self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
							} else {
								self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": data.message, "isLoading": false});
							}
						} catch (e){
							self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": data.message, "isLoading": false});	
						}
						// self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": data.message, "isLoading": false});
					}
				})
			}, 500);
		}
	},

	confirmPull : function(action, accountSlug, slug, files = {}){
		var self = this;
		const _actions = this.flux.actions;

		accountSlug = accountSlug.toLowerCase();
		slug = slug.toLowerCase();

		self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
		switch(action){
			case "open":
				this.dispatch (constants.CONFIRM_PULL, {"popup": true, "data": files});
				break;
			case "close":
				this.dispatch (constants.CONFIRM_PULL, {"popup": false});
				break;
			case "submit":
				this.dispatch (constants.CONFIRM_PULL, {"popup": false, "data": files});
				this.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "Please wait...", "isLoading": true});
				setTimeout(function(){
					_actions.pullDiff(true, accountSlug, slug, files);
				}, 500);
				break;
		}
	},

	cloneByVersionPopup: function(bool) {
		this.dispatch (constants.CLONE_BY_VERSION, {"popup": bool});
	},

	pullByVersion: function (bool, slug, version){
		//pull
		if(bool){
			var data= [ {"label": "andres_site_V2", "canonical": false, "date": "Wed Jan 25 2017 10:10:10 GMT+0530 (IST)"},
					{"label": "andres_site_V1", "canonical": false, "date": "Mon Dec 26 2016 05:05:05 GMT+0530 (IST)"},
					{"label": "new_bannerdesign_V2", "canonical": false, "date": "Wed Feb 01 2017 01:01:01 GMT+0530 (IST)"},
					{"label": "new_bannerdesign_V1", "canonical": false, "date": "Mon Dec 12 2016 01:41:10 GMT+0530 (IST)"},
					{"label": "new_bannerdesign_V3", "canonical": false, "date": "Wed Jan 25 2017 10:11:12 GMT+0530 (IST)"}];
			this.dispatch (constants.PULL_BY_VERSION, {"popup": bool, "data": data});
		} else {
			this.dispatch (constants.PULL_BY_VERSION, {"popup": bool});
		}
	},

	cloneByVersion: function(slug, version){
		const _actions = this.flux.actions;
		_actions.cloneByVersionPopup(false);  // close the pull by version popup
	},

	sharePackage: function(action, accountSlug = null, slug = null, receiver = null, message = null){
		const _actions = this.flux.actions;
		var self = this;
		switch(action){
			case "open":
				sessionStorage.setItem("initiatedAction", "sharePackage");
				this.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "Please wait...", "isLoading": true});
				_actions.host().getAccountDetails (accountSlug, (data, response) => {
					if(response){
						var resp = {};
						try{
							resp = JSON.parse(response.text);
						} catch(e){}
						if(response.status === 200){
							if(!resp.email){
								_actions.provideEmail("open");
							} else if(resp.email && !resp.verified){
								_actions.verifyEmail("open");
							} else {
								var opts = {"share": 1};
								_actions.host().sharedPackageListGet (accountSlug, slug, opts, (data, response) => {
									if(response){
										resp = {};
										try{
											resp = JSON.parse(response.text);
										} catch(e){
											
										}
										if(response.status === 200){
											self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
											self.dispatch (constants.SHARE_PACKAGE_POPUP, {"popup": true, "data": resp.items});
										} else if(response.status === 500 && resp.message == "Session not authenticated"){
											self.dispatch (constants.SIGNUP_POPUP, {"popup": true, "data": "", "action":  {"action":"sharePackageOpen", "accountSlug": accountSlug, "slug": slug}, "slug": accountSlug + "/" + slug}) // redirect to on-boarding popup
											self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
										} else {
											self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": resp.message});
										}
									} else if(data.message === "No session_key"){
										self.dispatch (constants.SIGNUP_POPUP, {"popup": true, "data": "", "action":  {"action":"sharePackageOpen", "accountSlug": accountSlug, "slug": slug}, "slug": accountSlug + "/" + slug}) // redirect to on-boarding popup
										self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
									} else {
										self.dispatch (constants.ERROR_MESSAGE, {"popup": true,  "error": true, "message": data.message});
									}
								});
							}
						} else if(response.status === 500 && resp.message == "Session not authenticated"){
							self.dispatch (constants.SIGNUP_POPUP, {"popup": true, "data": "", "action":  {"action":"sharePackageOpen", "accountSlug": accountSlug, "slug": slug}, "slug": accountSlug + "/" + slug}) // redirect to on-boarding popup
							self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
						}
					} else if(data.message === "No session_key"){
						self.dispatch (constants.SIGNUP_POPUP, {"popup": true, "data": "", "action":  {"action":"sharePackageOpen", "accountSlug": accountSlug, "slug": slug}, "slug": accountSlug + "/" + slug}) // redirect to on-boarding popup
						self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
					}
				});
				break;
			case "close":
				sessionStorage.removeItem("initiatedAction");
				this.dispatch (constants.SHARE_PACKAGE_POPUP, {"popup": false});
				break;
			case "submit":
				this.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "Please wait...", "isLoading": true});
				var errorCollect = [], i = 0, error = false, errArray = "";
				var loopArray = function(receiver){					let receivedUser = receiver[i++];
					var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
					let body = {"type" : "share"};
					if(re.test(receivedUser)){
						body["email"] = receivedUser;
					} else {
						body["account_slug"] = receivedUser;
					}
					if(message){
						body["message"] = message;
					}
					_actions.host().sharePackage(accountSlug, slug, body, (data, response) => {
						if(response){
							var resp = {};
							try{
								resp = JSON.parse(response.text);
							} catch(e){

							}
							if(response.status === 200){
								
							} else {
								errArray = `${errArray} Name/Email : ${receivedUser} and Error: ${resp.message}
											`;
								error = true;
								// self.dispatch ( constants.ERROR_MESSAGE, { "popup": true,"error": true, "message": resp.message } );
							}
						} else if(data.message === "No session_key"){
							self.dispatch (constants.SIGNUP_POPUP, {"popup": true, "data": "", "action":  {"action":"sharePackageSubmit", "accountSlug": accountSlug, "slug": slug, "receiver": receiver, "message": message}, "slug": accountSlug + "/"+ slug}); // redirect to on-boarding popup
							self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
						} else {
							errArray = `${errArray} Name/Email : ${receivedUser} and Error: ${resp.message}...`;
							error = true;
							// self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": data.message});
						}
						if(receiver.length-1 >= i){
							loopArray(receiver);
						} else {
							_actions.sharePackage("open", accountSlug, slug);
							if(error){
								self.dispatch ( constants.ERROR_MESSAGE1, { "popup": true, "error": true, "message": errArray } );
							}
						}					
					})
				}
				loopArray(receiver);
				break;
		}	
	},

	searchAccounts: function(value){
		const _actions = this.flux.actions;
		var self = this;

		_actions.host().searchAccounts (value, (data, response) => {
			if(response){
				let resp = {};
				try{
					resp = JSON.parse(response.text);
				} catch (e){}
				if(response.status === 200){
					self.dispatch(constants.LIST_OF_ACCOUNTS, {"data": resp.items});
				}
			}
		});
	},

	revoke: function(action, revokeId = null, accountSlug = null, slug = null){
		const _actions = this.flux.actions;
		var self = this;

		switch(action){
			case "open":
				this.dispatch(constants.REVOKE, {"popup": true, "revokeId": revokeId});
				break;
			case "close":
				this.dispatch(constants.REVOKE, {"popup": false});
				break;
			case "submit":
				var body = {"type": "share"};
				var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				if(re.test(revokeId)){
					body["email"] = revokeId;
				} else {
					body["account_slug"] = revokeId;
				}
				_actions.host().revokeSharedPackage (accountSlug, slug, body, (data, response) => {
					if (response) {
						let resp = {};
						try{
							resp = JSON.parse(response.text);
						} catch(e){}
						if(response.status === 200){
							_actions.sharePackage("open", accountSlug, slug);
						}
					}
				});
				this.dispatch(constants.REVOKE, {"popup": false, "revokeId": revokeId});
				break;
		}	
	},

	
	reject: function(action, list = null, accountSlug = "", slug = ""){
		const _actions = this.flux.actions;
		var self = this;
		switch(action){
			case "open":
				this.dispatch(constants.REJECT_POPUP, {"popup": true, "data": list});
				break;
			case "close":
				this.dispatch(constants.REJECT_POPUP, {"popup": false, "data": list});
				break;
			case "submit":
				var body = Object.assign(list, {"action": "share"});
				_actions.host().rejectPackage (accountSlug, slug, body, (data, response) => {
					if(response){
						let resp = {};
						try {
							resp = JSON.parse(response.text);
						} catch(e){}
						if(response.status === 200){
							_actions.reject("close");
							window.history.back()
						} else {
							_actions.reject("close");
							self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": resp.message});
						}
					} else {
						_actions.reject("close");
						self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": data.message});
					}
				})
		}
	},

	rejectOffensive: function(action, list = null, accountSlug, slug){
		const _actions = this.flux.actions;
		var self = this;

		switch(action){
			case "open":
				this.dispatch(constants.REJECT_OFFENSIVE_POPUP, {"popup": true, "data": list});
				break;
			case "close":
				this.dispatch(constants.REJECT_OFFENSIVE_POPUP, {"popup": false, "data": list});
				break;
			case "submit":
				_actions.host().rejectPackage (accountSlug, slug, list, (data, response) => {
					if(response){
						let resp = {};
						try {
							resp = JSON.parse(response.text);
						} catch(e){}
						if(response.status === 200){
							_actions.rejectOffensive("close");
							window.history.back()
						} else {
							_actions.reject("close");
							self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": resp.message});
						}
					} else {
						_actions.reject("close");
						self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": data.message});
					}
				});
		}
	},

	conflictError: function(action){
		switch(action){
			case "open":
				this.dispatch (constants.CONFLICT_ERROR_POPUP, {"popup": true});
				break;
			case "close":
				this.dispatch (constants.CONFLICT_ERROR_POPUP, {"popup": false});
				break;
		}	
	},

	browse: function(slug){
		alert("coming soon")
		// TODO
	},


	provideEmail : function(action, accountSlug = null, slug = null, email = ""){
		const _actions = this.flux.actions;
		var self = this;

		switch(action){
			case "open":
				this.dispatch (constants.PROVIDE_EMAIL_POPUP, {"popup": true});
				this.dispatch (constants.ERROR_MESSAGE, {"popup": false});
				break;
			case "close":
				this.dispatch (constants.PROVIDE_EMAIL_POPUP, {"popup": false});
				break;
			case "submit":
				this.dispatch (constants.ERROR_MESSAGE, {"popup": true, "isLoading": true, "message": "Please wait..."});
				var body = {"email": email};
				_actions.host().updateAccount (accountSlug, body, (data, response) => {
					if(response){
						var resp = {};
						try {
							resp = JSON.parse(response.text);
						} catch(e){}
						if(response.status === 200){
							_actions.provideEmail("close");
							_actions.verifyEmail("open", accountSlug, slug);
						} else {
							_actions.provideEmail("close");
							self.dispatch ( constants.ERROR_MESSAGE, { "popup": true, "error": true, "message": resp.message } );
						}
					} else {
						_actions.provideEmail("close");
						self.dispatch ( constants.ERROR_MESSAGE, { "popup": true, "error": true, "message": data.message } );
					}
				});
		}
	},

	verifyEmail: function(action, accountSlug = null, slug = null, email = ""){
		const _actions = this.flux.actions;
		var self = this;

		switch (action){
			case "open":
				this.dispatch (constants.VERIFY_EMAIL_POPUP, {"popup": true});
				this.dispatch (constants.ERROR_MESSAGE, {"popup": false});
				break;
			case "close":
				this.dispatch (constants.VERIFY_EMAIL_POPUP, {"popup": false});
				break;
			case "continue":
				self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "Please wait...", "isLoading": true});
				_actions.host().getAccountDetails (accountSlug, (data, response) => {
					if(response){
						var resp = {};
						try{
							resp = JSON.parse(response.text);
						} catch(e){}
						if(response.status === 200){
							if(resp.email && !resp.verified){
								self.dispatch (constants.ERROR_MESSAGE, {"popup": false, "error": true, "message": "Please click on verify link that was sent to your email first."});
							} else {
								let initiatedAction = sessionStorage.getItem("initiatedAction");
								if(initiatedAction) _actions[initiatedAction]("open", accountSlug, slug);
							}
						} else {
							self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": resp.message, "isLoading": true});
						}
					} else {
						self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": data.message, "isLoading": true});
					}
				});
				this.dispatch (constants.VERIFY_EMAIL_POPUP, {"popup": false});
				break;
			case "submit":
				_actions.host().verifyEmail (accountSlug, slug, email, (data, response) => {
					if(response){
						var resp = {};
						try{
							resp = JSON.parse(response.text);
						} catch(e){}
						if(response.status === 200){
			
						} else {
							_actions.verifyEmail("close");
							self.dispatch ( constants.ERROR_MESSAGE, { "popup": true, "error": true, "message": resp.message } );
						}
					} else {
						_actions.verifyEmail("close");
						self.dispatch ( constants.ERROR_MESSAGE, { "popup": true, "error": true, "message": data.message } );
					}
				});
		}
	},

	getSharedPackages: function(){
 		var self = this;
 		let opts = {"share": "1"};
 		const _actions = this.flux.actions;

		_actions.host().getPackages (opts, (data, response) => {
			if(response){
				if(response.status === 200){
					self.dispatch ( constants.INIT_DATA , {data : data.items});
				} else {
					try {
					var obj = JSON.parse (response.text);
						self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": obj.message});
				    } catch(e) {
				    	self.dispatch (constants.ERROR_MESSAGE, {"error": true, "message": "Unable to parse error"});
				    }
				}
			} else if(data.message.search("the network is offline") > -1){
				self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "Network is offline."});
			}
		});
 	},

 	resendInvite: function(accountSlug, slug, body){
 		var self = this;
 		const _actions = this.flux.actions;
 		self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "Please wait...", "isLoading": true});
 		_actions.host().resendInvite(accountSlug, slug, body, (data, response) => {
 			if(response){
 				let resp = {};
 				try{
 					resp = JSON.parse(response.text)
 				} catch(e){}
 				if(response.status === 200){
 					self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
 				} else {
 					self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": resp.message});
 				}
 			} else {
 				self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": data.message});
 			}
 		})
 	},


	/* below are sign up poupup functions */

	loginClick: function(username, password,  action = null, slug = ""){
		var self = this;
 		const _actions = this.flux.actions;

		slug = slug.toLowerCase();

 		_actions.host().login(username,password, function(data , error){
 			try{
 				data = JSON.parse(JSON.stringify(data));
 			} catch (e){
 				data= {};
 			}
			if (data.hasOwnProperty("session_key")) {
				var slugArray = slug.split("/");
				_actions.getDetailData(data.slug, slugArray[1]);
				self.dispatch ( constants.SIGNIN_DATA , {data : {signIn : true, session_key: data.session_key, slug: data.slug} } );
				localStorage.setItem ("userSlug" , data.slug);
				// window.location.href = "?page=Library";
				self.dispatch (constants.SIGNUP_POPUP, {"popup": false});
				if(action.action == "pull" || action === "pull"){
					_actions.pull(data.slug + "/" + slugArray[1]);
					self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "Please wait...", "isLoading": true});
				}else if (action.action == "push" || action === "push"){
					_actions.push(data.slug + "/" + slugArray[1]);
					self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "Please wait...", "isLoading": true});
				} else if (action.action === "pushDiff"|| action === "pushDiff"){
					_actions.pushDiff(false, data.slug, slugArray[1], action.files, action.packageHash)
				} else if (action.action === "pullDiff"|| action === "pullDiff"){
					_actions.pullDiff(false, data.slug, slugArray[1], action.files)
				} else if(action.action == "cloneSubmit" || action === "cloneSubmit"){
					_actions.clone("submit", action.accountSlug, action.slug, action.slug2);
				} else if(action.action == "cloneOpen" || action === "cloneOpen"){
					_actions.clone("open", action.accountSlug, action.slug);
				} else if (action.action === "pullPackage" || action === "pullPackage"){
					_actions.pullPackage(action.accountSlug, action.slug2, action.slug);
				} else if(action.action === "draftCreate" || action === "draftCreate"){
					_actions.draftCreate(action.accountSlug, action.slug2, action.body);
				} else if (action.action === "snapshotOpen" || action === "snapshotOpen"){
					_actions.snapshot("open", action.version, data.slug + "/" + action.package_name.split("/")[1], action.data);
				} else if (action.action === "snapshotSubmit" || action === "snapshotSubmit"){
					_actions.snapshot("submit", action.version, data.slug + "/" + action.package_name.split("/")[1], action.data);
				} else if(action.action === "makeCanonical" || action === "makeCanonical"){
					_actions.makeCanonicalSnapshot(action.label, data.slug, action.slug, action.versions);
				} else if(action.action === "sharePackageOpen" || action === "sharePackageOpen"){
					_actions.sharePackage("open", data.slug, action.slug);
				} else if (action.action === "sharePackageSubmit" || action === "sharePackageSubmit"){
					_actions.sharePackage("submit", data.slug, action.slug, action.receiver, action.message);
				}
			} else if (typeof data === "object" && data.hasOwnProperty("response") && data.response.hasOwnProperty("text") &&  data.response.text.search("Package Conflict occured") > -1) {
				self.dispatch(constants.SIGNUP_POPUP, {"popup": false});
				_actions.conflictError("open");
			} else if(typeof data ==="object" && data.hasOwnProperty("message") && typeof data.message === "string" && data.message.search("the network is offline") > -1){
				self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "It seems you are offline. Please check your network connection and try again."});
			} else if(data.status === 500){
				self.dispatch (constants.SIGNIN_ERROR, {error: true});
			} 

		});
 	},

 	signUp: function(flag, name = null,  username = null, password = null, email = null, action = null, slug = ""){
	 	var self = this;
		slug = slug.toLowerCase();
 		if(!flag && name == null){
 			this.dispatch (constants.SIGNUP_POPUP, {"popup": false});
 		} else {
	 		const _actions = this.flux.actions;
	 		var body = {};
 		    body['name'] = "";
 		    body['userName'] = username;
 		    body['password'] = password;
 		    if(email !== ""){
 		    	body['email'] = email;
 		    }
	 		_actions.host().createAccount(body, function(data, response){
	 			if(response){
		 			if(response.status === 200){
		 				// window.location.href = "#/active?username="+ username;	
		 				self.dispatch (constants.SIGNUP_DATA, {});
		 				self.dispatch (constants.SIGNUP_POPUP, {"popup": false, "data": username});
		 				_actions.loginClick(username, password, action, slug);
		 			} else {
		 				self.dispatch (constants.SIGNUP_ERROR, {error: true});
		 			}
		 		}  else if(typeof data ==="object" && data.hasOwnProperty("message") && typeof data.message === "string" && data.message.search("the network is offline") > -1){
					self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "It seems you are offline. Please check your network connection and try again."});
				}  else {
		 			self.dispatch (constants.SIGNUP_ERROR, {error: true});
		 		}
	 		});
	 	}
 	},

 	activeUser: function(flag, token = null, slug= ""){
	 	var self = this;
		slug = slug.toLowerCase();
		const _actions = this.flux.actions;

 		if(flag){
 			this.dispatch(constants.ACTIVATEUSER_POPUP, {"popup": true});
 		} else if(token == null){
 			this.dispatch(constants.ACTIVATEUSER_POPUP, {"popup": false});
 		} else {
	 		var body = {};
	 		body["activationToken"] = token;
	 		_actions.host().updateAccount(slug, body, (data,response) => {
	 			if(response){
	 				if(response.status === 200){
	 					// window.location.href = "?page=Onboard";
	 					self.dispatch(constants.ACTIVATEUSER_POPUP, {"popup": false});
	 					self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": false, "message": "Account has been created successfully.", "isLoading": false});
	 				}else{
	 					self.dispatch (constants.ACTIVEUSER_ERROR, {"error": true})
	 				}
	 			} else if(typeof data ==="object" && data.hasOwnProperty("message") && typeof data.message === "string" && data.message.search("the network is offline") > -1){
					self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "It seems you are offline. Please check your network connection and try again."});
				}  else {
	 				self.dispatch (constants.ACTIVEUSER_ERROR, {"error": true})
	 			}
	 		})
	 	}
 	},

 	resetPassword: function(action, email = null){
 		var self = this;
 		const _actions = this.flux.actions;

 		if(action === "open"){
 			this.dispatch (constants.SIGNUP_POPUP, {"popup": false, "data": email.data, "slug": email.slug });
 			this.dispatch (constants.FORGOT_PASSWORD_POPUP, {"popup": true});
 		} else if(action === "close"){
 			this.dispatch (constants.FORGOT_PASSWORD_POPUP, {"popup": false});
 		} else	{
	 		var body = {};
	 		body["user_name"] = email;
	 		_actions.host().resetPassword (body, function(data, response){
	 			if(response){
		 		 	if(response.status === 200){
		 		 		console.log("sent...")
		 		 	}
		 		 	else{
	 					self.dispatch (constants.FORGOT_ERROR, {error: true});
		 		 		console.log("error")
		 		 	}
		 		}  else if(typeof data ==="object" && data.hasOwnProperty("message") && typeof data.message === "string" && data.message.search("the network is offline") > -1){
					self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "It seems you are offline. Please check your network connection and try again."});
				}  else {
		 			self.dispatch (constants.FORGOT_ERROR, {error: true});
		 			console.log(data.message);
		 		}
	 		});
	 	}
 	},

 	clearLoginErrors: function(){
 		this.dispatch (constants.CLEAR_LOGIN_ERRORS);
 	},

 	cloneSuccess: function(action, accountSlug= "", slug= ""){
 		var self = this;
 		const _actions = this.flux.actions;
 		accountSlug = accountSlug.toLowerCase();
		slug = slug.toLowerCase();
 		switch(action){
 			case "open":
 				this.dispatch (constants.CLONE_SUCCESS_POPUP, {"popup": true, "newSlug": slug, "accountSlug": accountSlug});
 				break;
 			case "close":
 				this.dispatch (constants.CLONE_SUCCESS_POPUP, {"popup": false});
 				break;
 			case "openDetail":
 				_actions.getDetailData(accountSlug, slug);
 				this.dispatch (constants.CLONE_SUCCESS_POPUP, {"popup": false});
 				break;
 		}
 	},

 	cloneWarning: function(action, slug=""){
		slug = slug.toLowerCase();
 		switch(action){
 			case "open":
 				this.dispatch (constants.CLONE_WARNING_POPUP, {"popup": true, "slug": slug});
 				break;
 			case "close":
 				this.dispatch (constants.CLONE_WARNING_POPUP, {"popup": false});
 				break;
 		}
 	},

 	backToLogin: function(action){
 		this.dispatch (constants.FORGOT_PASSWORD_POPUP, {"popup": false});
 		this.dispatch (constants.SIGNUP_POPUP, {"popup": true, "data": action.data, "slug": action.slug});
 	},


 	transferPackage: function(action, accountSlug = "", slug = "", receiver= ""){
		/* for transfering a theme */
		var self = this;
		const _actions = this.flux.actions;

		slug = slug.toLowerCase();

		switch(action){
			case "open":
				sessionStorage.setItem("initiatedAction", "transferPackage");
				this.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "Please wait...", "isLoading": true});
				_actions.host().getAccountDetails (accountSlug, (data, response) => {
					if(response){
						var resp = {};
						try{
							resp = JSON.parse(response.text);
						} catch(e){}
						if(response.status === 200){
							if(!resp.email){
								_actions.provideEmail("open");
							} else if(resp.email && !resp.verified){
								_actions.verifyEmail("open");
							} else {
								this.dispatch (constants.TRANSFER_PACKAGE_POPUP, {"popup": true});
							}
						} else if(response.status === 500 && resp.message == "Session not authenticated"){
							self.dispatch (constants.SIGNUP_POPUP, {"popup": true, "data": "", "action":  {"action":"transferPackageOpen", "accountSlug": accountSlug, "slug": slug}, "slug": accountSlug + "/" + slug}) // redirect to on-boarding popup
							self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
						}
					} else if(data.message === "No session_key"){
						self.dispatch (constants.SIGNUP_POPUP, {"popup": true, "data": "", "action":  {"action":"transferPackageOpen", "accountSlug": accountSlug, "slug": slug}, "slug": accountSlug + "/" + slug}) // redirect to on-boarding popup
						self.dispatch (constants.ERROR_MESSAGE, {"popup": false});
					}
				});
				break;
			case "close":
				this.dispatch (constants.TRANSFER_PACKAGE_POPUP, {"popup": false});
				break;
			case "submit":
				_actions.transferRUSure("open", accountSlug, slug, receiver);
		}
	},

	transferRUSure: function(action, accountSlug = "", slug = "", receiver= ""){
		var self = this;
		const _actions = this.flux.actions;

		slug = slug.toLowerCase();

		switch(action){
			case "open":
				this.dispatch (constants.TRANSFER_R_U_SURE_POPUP, {"popup": true, "data": receiver});
				break;
			case "close":
				this.dispatch (constants.TRANSFER_R_U_SURE_POPUP, {"popup": false});
				break;
			case "submit":
				_actions.transferRUSure("close");
				_actions.transferPackage("close");
				_actions.transferSuccess("open", accountSlug, slug, receiver);
				// _actions.host().transferPackage(accountSlug, slug, receiver, function (data, response){
				// 	if(response){
				// 		if(response.status === 200){
				// 			self.dispatch (constants.TRANSFER_DATA, {error: false})
				// 		}
				// 		else{
				// 			try {
				// 			var obj = JSON.parse (response.text);
				// 				self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": obj.message});
				// 		    } catch(e) {
				// 		    	self.dispatch (constants.ERROR_MESSAGE, {"error": true, "message": "Unable to parse error"});
				// 		    }
				// 		}
				// 	} else if(typeof data ==="object" && data.hasOwnProperty("message") && typeof data.message === "string" && data.message.search("the network is offline") > -1){
				// 		self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": "It seems you are offline. Please check your network connection and try again."});
				// 	} else {
				// 		self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": data.message});
				// 	}
				// });
		}
	},

	transferSuccess: function(action, accountSlug = "", slug= "", receiver = ""){
		var self = this;
		const _actions = this.flux.actions;

		switch(action){
			case "open":
				this.dispatch (constants.TRANSFER_SUCCESS_POPUP, {"popup": true, "data": receiver});
				break;
			case "close":
				this.dispatch (constants.TRANSFER_SUCCESS_POPUP, {"popup": false});
				break;
			case "pendingTransfers":
				break;
			case "revoke":
				_actions.transferRevoke("open", accountSlug, slug);
				break;
		}
	},

	transferRevoke: function(action, accountSlug= "", slug = ""){
		var self = this;
		const _actions = this.flux.actions;

		switch(action){
			case"open":
				this.dispatch (constants.TRANSFER_REVOKE_POPUP, {"popup": true});
				break;
			case "close":
				this.dispatch (constants.TRANSFER_REVOKE_POPUP, {"popup": false});
				break;
			case "revoke":

				break;
		}		
	},


	transferWarningDependencies: function (action, data = null){
		var self = this;
		const _actions = this.flux.actions;

		switch(action) {
			case "open":
				this.dispatch (constants.TRANSFER_WARNING_DEPENDENCIES_POPUP, {"popup": true, "data": data});
				break;
			case "close":
				this.dispatch (constants.TRANSFER_WARNING_DEPENDENCIES_POPUP, {"popup": true});
				break;
			case "submit":
				this.dispatch (constants.TRANSFER_WARNING_DEPENDENCIES_POPUP, {"popup": false});
				break;
		}
	},

	updatePackage: function(action, accountSlug, slug) {
		var self = this;
		const _actions = this.flux.actions;

		switch(action) {
			case "open" :
				_actions.host().versionList(accountSlug, slug, (data, response) => {
					if(response){
						var resp = {};
						try{
							resp = JSON.parse(response.text);
						} catch(e){};
						if(response.status === 200){
							for(var i in resp.items){
								resp.items[i]["canonical"] = false;
							}
							self.dispatch (constants.UPDATE_PACKAGE_POPUP, {"popup": true, "data": resp.items});
						} else {
							self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": response.message});
						}
					} else {
						self.dispatch (constants.ERROR_MESSAGE, {"popup": true, "error": true, "message": data.message});
					}
				});
				break;
			case "close":
				this.dispatch (constants.UPDATE_PACKAGE_POPUP, {"popup": false});
				break;
			case "submit":
				this.dispatch (constants.UPDATE_PACKAGE_POPUP, {"popup": false});
				break;
		}		
	}
	
};

module.exports = {actions};


/** WEBPACK FOOTER **
 ** ./html/actions/actions.js
 **/